// css
import "./Logo.css"
const Logo = () => {
    return (
        <div id = "logo" className="h-screen w-full rounded">
            
        </div>
    )
}
export default Logo;